export var phonesWrap = function phonesWrap(theme) {
  return {
    '& .phones-input-row': {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.8em',
      '@media (max-width: 576px)': {
        flexDirection: 'column',
        alignItems: 'stretch'
      }
    },
    '& .phones-input-field': {
      flex: 1,
      minWidth: 0
    },
    '& .phones-add-btn': {
      flexShrink: 0,
      alignSelf: 'flex-start',
      marginTop: 'calc(1.3rem * 1.4 + 0.39rem)'
    },
    '& .phones-list': {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.6em',
      marginTop: '1em'
    },
    '& .phone-chip': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.4em',
      padding: '0.4em 0.5em 0.4em 0.8em',
      backgroundColor: theme.gray50,
      border: "1px solid ".concat(theme.gray200),
      fontSize: '1.3rem',
      color: theme.gray700,
      '& .phone-chip-remove': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '2rem',
        height: '2rem',
        cursor: 'pointer',
        color: theme.gray400,
        fontSize: '1.3rem',
        transition: 'color 0.15s ease',
        '&:hover': {
          color: theme.error
        }
      }
    },
    '& .phones-empty': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5em',
      marginTop: '1em',
      padding: '0.6em 1em',
      backgroundColor: theme.warningLight,
      color: theme.warningDark,
      fontSize: '1.2rem',
      '& i': {
        fontSize: '1.4rem'
      }
    }
  };
};